import React, { Component } from "react";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import ScrollAnimation from "react-animate-on-scroll";
import { Styles } from "./styles/mission.js";

class Mission extends Component {
  render() {
    return (
      <Styles>
        {/* Main Wrapper */}
        <div className="main-wrapper mission-page">
          {/* Header */}
          <Header />

          {/* Breadcrumb */}
          <BreadcrumbBox title="Mission" img="slider1.jpg" />

          {/* Mission Content */}
          <section className="mission-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <ScrollAnimation animateIn="fadeInUp" duration={1}>
                    <div className="mission-content">
                      <div className="mission-header">
                        <div className="mission-icon">
                          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="#4A90E2"/>
                            <path d="M12 16L13.09 22.26L20 23L13.09 23.74L12 30L10.91 23.74L4 23L10.91 22.26L12 16Z" fill="#4A90E2" opacity="0.6"/>
                          </svg>
                        </div>
                        <h2 className="mission-title">Mission</h2>
                      </div>
                      
                      <div className="mission-text">
                        <p>
                          To enable systematic change within the Department of Public Health Engineering (DPHE) 
                          and its partners by fostering collaboration, building capacity, and driving policy advocacy 
                          for the implementation of the Citywide Inclusive Sanitation (CWIS) approach—accelerating 
                          Bangladesh's progress toward SDG 6.2 through strengthened governance, regulation, financing 
                          and promoting innovative technology for sanitation and waste management.
                        </p>
                      </div>

                      <div className="mission-highlights">
                        <div className="highlight-item">
                          <div className="highlight-icon">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 7.5V9M15 11.5V9.5L21 9V11L15 11.5ZM21 13V11L15 11.5V13.5L21 13ZM22 22H2L4 20L2 18L4 16L2 14L4 12L2 10L4 8L2 6L4 4L2 2H22V22Z" fill="#28A745"/>
                            </svg>
                          </div>
                          <div className="highlight-content">
                            <h4>Systematic Change</h4>
                            <p>Enabling transformation within DPHE and partner organizations</p>
                          </div>
                        </div>

                        <div className="highlight-item">
                          <div className="highlight-icon">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M16 4C18.2 4 20 5.8 20 8C20 10.2 18.2 12 16 12C13.8 12 12 10.2 12 8C12 5.8 13.8 4 16 4ZM8 4C10.2 4 12 5.8 12 8C12 10.2 10.2 12 8 12C5.8 12 4 10.2 4 8C4 5.8 5.8 4 8 4ZM8 14C11.3 14 14 16.7 14 20V22H2V20C2 16.7 4.7 14 8 14ZM16 14C19.3 14 22 16.7 22 20V22H16V20C16 18.4 15.4 16.9 14.4 15.8C15.5 14.6 17.1 14 19 14H16Z" fill="#FF6B35"/>
                            </svg>
                          </div>
                          <div className="highlight-content">
                            <h4>Collaboration & Capacity Building</h4>
                            <p>Fostering partnerships and strengthening organizational capabilities</p>
                          </div>
                        </div>

                        <div className="highlight-item">
                          <div className="highlight-icon">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z" fill="#FFD700"/>
                            </svg>
                          </div>
                          <div className="highlight-content">
                            <h4>SDG 6.2 Progress</h4>
                            <p>Accelerating Bangladesh's journey toward sustainable sanitation goals</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ScrollAnimation>
                </div>
              </div>
            </div>
          </section>

          {/* Footer */}
          <Footer />
        </div>
      </Styles>
    );
  }
}

export default Mission;